import gql from 'graphql-tag';

export const GetApprovalTaskItemByIdQuery = gql`
  query GetApprovalTaskItemByIdQuery($id: String){
    approvalTaskItem(id: $id) {
      id
      name
      itemNote
      typeCode
      typeCodeOptionSet
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      allowRecordCreation
      isRequired
      payloadTypeCode
      payloadTypeCodeOptionSet
      payloadName
      payload
      submitDate
      submissionReject
      ebbModifiedDate
      ebbModifiedByTypeOptionSet
      approvalTaskItemKey
    }
  }
`;
